import React from 'react';
import Navbar from '../global/Navbar';
import Footer from '../global/Footer';
import PricingDetails from './PricingDetails';
import Newsletter from '../global/Newsletter';
import { PageFlow } from '../shared/SectionSurface';
import PageMeta from '../shared/PageMeta';

function Pricing() {
  return (
    <div>
      <PageMeta path="/pricing" />
      <Navbar />
      <PageFlow>
        <PricingDetails />
      </PageFlow>
      <Newsletter />
      <Footer />
    </div>
  );
}

export default Pricing;
